import React, { useState } from 'react';
import { Button, Popconfirm, Space } from 'antd';
import { EditOutlined, DeleteOutlined, EyeOutlined, DeleteFilled } from '@ant-design/icons';
import { exportToCSV, getB2BUsers, getUsersList } from '../../store/slices/userSlice';
import TableComponent from '../../components/TableComponent';
import { useNavigate } from 'react-router';
import { deleteChatQuestion, getChatQuestion } from '../../store/slices/chatQuestionSlice';
import { useDispatch } from 'react-redux';

const ChatQuestionList = () => {
    const dispatch = useDispatch();
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [reload, setReload] = useState(false)
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const navigate = useNavigate();
    const columns = [
        {
            title: 'Question',
            dataIndex: 'question',
            key: 'question',
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, data) => (
                <Space>
                    <Button onClick={() => navigate('/chat-question/edit/' + data?._id)} icon={<EditOutlined />} size="small">Edit</Button>
                    {/* <Button icon={<DeleteOutlined />} size="small" danger>Delete</Button> */}
                    <Popconfirm
                        title="Delete confirmation"
                        description="Do you want to delete this?"
                        open={open == data?._id}
                        icon={<DeleteFilled />}
                        onConfirm={() => handleDeleteChatQuestion(data?._id)}
                        okButtonProps={{ loading: confirmLoading }}
                        onCancel={handleCancel}
                    >
                        <Button icon={<DeleteOutlined />} onClick={() => showPopconfirm(data?._id)} size="small" danger>Delete</Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const showPopconfirm = (chatQuestionId) => {
        setOpen(chatQuestionId);
    };

    const handleDeleteChatQuestion = async (id) => {
        try {
            setConfirmLoading(true);

            const resultAction = await dispatch(deleteChatQuestion(id))
            if (deleteChatQuestion.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || "Deleted")
                setAlertType('success')
                setReload(!reload)
                setOpen(false);
                setConfirmLoading(false);
                setTimeout(() => {
                    setAlertMessage('');
                }, 4000);
            }
        } catch (error) {
            setConfirmLoading(false);
            setAlertMessage("Error deleting truck")
            setAlertType('error')
            setOpen(null);
        }
        
    };

    const handleCancel = () => {
        console.log('Clicked cancel button');
        setOpen(false);
    };

    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Chat Questions</h1>
                <span>
                    <Button type="primary" onClick={() => navigate('/chat-question/add')}>Add Chat Question</Button>
                </span>
            </div>
            <TableComponent
                listData={getChatQuestion}
                columns={columns}
                reload={reload}
                placeholder="Search questions..."
            />
        </div>
    );
};

export default ChatQuestionList;

